<template>
    <div class="navbar-container">
        <hamburger class="hamburger-container"></hamburger>
        <breadcrumb class="breadcrumb-container"></breadcrumb>
        <div class="right-menu">
<!--            <span>{{nickname}}</span>-->
            <!-- 超级管理员租户切换器（PC 与手机端均展示） -->
            <el-select
                v-if="isSuperAdmin"
                class="right-menu-item hover-effect tenant-switch"
                size="small"
                v-model="currentTenant"
                placeholder="切换租户"
                @change="handleSwitchTenant"
                :loading="tenantLoading"
            >
                <el-option
                    v-for="item in tenantOptions"
                    :key="item.tenantId"
                    :label="item.companyName || item.tenantId"
                    :value="item.tenantId"
                />
            </el-select>

            <template v-if="device!=='mobile'">
                <!--        <el-tooltip effect="dark" content="博客地址" placement="bottom">-->
                <!--          <a :href="blogUrl" target="__blank">-->
                <!--            <svg-icon icon="link" class="right-menu-item hover-effect"></svg-icon>-->
                <!--          </a>-->
                <!--        </el-tooltip>-->

                <el-tooltip effect="dark" content="全屏展示" placement="bottom">
                    <screen-full class="right-menu-item hover-effect"></screen-full>
                </el-tooltip>
            </template>

            <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click" size="small">
                <div class="avatar-wrapper">
                    <img :src="avatarUrl" class="user-avatar">
                    <i class="el-icon-caret-bottom"/>
                </div>
                <el-dropdown-menu slot="dropdown" class="dropdown-menu-item">
                    <router-link to="/user/profile">
                        <el-dropdown-item icon="el-icon-setting">个人中心</el-dropdown-item>
                    </router-link>
                    <el-dropdown-item icon="el-icon-switch-button" divided @click.native="logout">
                        <span>退出登录</span>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>

<script>
import {resetRouter} from '../router/index'
import ScreenFull from '../components/ScreenFull/index.vue'
import Hamburger from './components/Hamburger.vue'
import Breadcrumb from './components/Breadcrumb.vue'
import {mapGetters} from 'vuex'
import global from "@/api/global";
import { reqListSysTenant } from "@/api/system/tenant";
import { reqSwitchTenant } from "@/api/system/users";
import { setItem } from '@/utils/cookie'
import { TENANT_ID } from '@/constant/index'

export default {
    name: 'NavBar',

    components: {Hamburger, Breadcrumb, ScreenFull},

    data() {
        return {
            // 项目Gitee地址
            // 博客前台地址
            blogUrl: 'https://www.zrkizzy.com',
            filePre: global.preview_path_url,
            // 当前操作租户（超级管理员可切换）
            currentTenant: this.$store.getters.tenantId || '',
            // 可切换的租户列表
            tenantOptions: [],
            tenantLoading: false,
        }
    },

    computed: {
        ...mapGetters(['avatar', 'device', 'isCollapse','nickname','roles', 'isSuperAdmin']),
        avatarUrl() {
            if (!this.avatar) return ''
            // 已经是完整 URL（http/https/data:）→ 直接使用
            if (this.avatar.startsWith('http') || this.avatar.startsWith('data:')) return this.avatar
            // 已经是绝对路径（webpack 打包的）→ 直接使用
            if (this.avatar.startsWith('/')) return this.avatar
            // 相对路径 → 拼接 filePre 前缀
            return this.filePre + this.avatar
        }
    },

    created() {
        // 超级管理员登录后加载可切换的租户列表
        if (this.isSuperAdmin) {
            this.loadTenantOptions()
        }
    },

    methods: {
        async loadTenantOptions() {
            this.tenantLoading = true
            try {
                const data = await reqListSysTenant({ currentPage: 1, pageSize: 100 })
                this.tenantOptions = data.records || []
            } finally {
                this.tenantLoading = false
            }
        },
        /**
         * 超级管理员切换租户：改写后端会话租户，刷新页面使菜单/路由/数据租户全部同步
         */
        handleSwitchTenant(tenantId) {
            if (!tenantId) return
            this.$confirm('切换租户后，当前页面数据将归属新租户，是否继续？', '切换租户', {
                confirmButtonText: '确定切换',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                reqSwitchTenant({ tenantId }).then(async () => {
                    this.$message.success('已切换到租户：' + tenantId)
                    // 记录到前端状态与 cookie（不刷新页面，避免 token 被重新校验而跳登录）
                    this.$store.commit('user/SET_TENANT_ID', tenantId)
                    setItem(TENANT_ID, tenantId)
                    // 动态重置并重新生成路由，使菜单/数据以新租户上下文加载
                    resetRouter()
                    const accessRoutes = await this.$store.dispatch('permission/generateRoutes')
                    accessRoutes.forEach(route => this.$router.addRoute(route))
                    // 重新匹配当前路由，使侧边栏与权限即时生效
                    this.$router.replace({ ...this.$route, replace: true })
                }).catch(() => {})
            }).catch(() => {
                // 取消则还原选择
                this.currentTenant = this.$store.getters.tenantId
            })
        },
        /**
         * 用户退出方法
         */
        async logout() {
            this.$confirm('确定注销并退出系统吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$store.dispatch('user/logout').then(() => {
                    location.href = '/login'
                    // 重置路由
                    resetRouter()
                })
            }).catch(() => {
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.navbar-container {
    height: 50px;
    box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
    background: #fff;
}

.hamburger-container {
    float: left;
    height: 100%;
    line-height: 46px;
    padding: 0 15px;
    cursor: pointer;
    // hover 动画
    transition: background 0.5s;

    &:hover {
        background-color: rgba(0, 0, 0, 0.1);
    }
}

.breadcrumb-container {
    float: left;
    height: 100%;
    line-height: 50px;
    margin-left: 0.5rem;
}

.right-menu {
    float: right;
    height: 100%;
    display: flex;
    align-items: center;

    &:focus {
        outline: none;
    }

    .right-menu-item {
        display: inline-block;
        padding: 0 8px;
        color: #5a5e66;
        vertical-align: text-bottom;

        &.svg-icon {
            font-size: 18px;
        }

        &.tenant-switch {
            width: 160px;
        }

        &.hover-effect {
            cursor: pointer;
            transition: background .3s;

            &:hover {
                background: rgba(0, 0, 0, .025)
            }
        }
    }

    .avatar-container {
        margin-right: 30px;

        .avatar-wrapper {
            position: relative;
            display: flex;
            align-items: center;

            .user-avatar {
                cursor: pointer;
                width: 40px;
                height: 40px;
                border-radius: 10px;
            }

            .el-icon-caret-bottom {
                cursor: pointer;
                position: absolute;
                right: -20px;
                top: 28px;
                font-size: 12px;
            }
        }
    }
}

.dropdown-menu-item {
    width: 120px;
    margin-right: -20px;
}

// 手机端（窄屏）：保留并紧凑化租户切换器，隐藏面包屑以腾出空间
@media screen and (max-width: 768px) {
    .breadcrumb-container {
        display: none;
    }

    .right-menu {
        .tenant-switch {
            width: 110px;
        }

        .avatar-container {
            margin-right: 8px;
        }
    }
}
</style>
